// JOBE-0162.5: fire-and-forget audit shim.
//
// In v1 this is `console.debug` in development, no-op in production.
// A real audit-wire hook lands in a followup spec; consumers call
// `emitAudit(eventName, payload)` and let the shim swallow the result.

/**
 * Emit an audit event.
 *
 * @param {string} eventName  Short event slug (e.g. 'slack-handoff').
 * @param {object} [payload]  JSON-serializable context.
 */
export function emitAudit(eventName, payload) {
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production') {
    return;
  }
  // eslint-disable-next-line no-console
  console.debug('[audit]', eventName, payload);
}
